import { RouteObject } from "react-router-dom";

const eDeliveryRoutes: RouteObject[] = [
	{ path: "/edelivery-konfiguracija", lazy: () => import("@/pages/eDelivery/EDeliveryConfigurationPage") },
];

export default eDeliveryRoutes;
